import config from './../modules/Config/Config';

let dataLayer;

if (typeof window !== 'undefined') {
  dataLayer = window.dataLayer || [];
  window.dataLayer = dataLayer;
} else {
  dataLayer = [];
}

(function() {
  if (config.adwordsTrackingId) {
    var gads = document.createElement('script');
    gads.async = true;
    gads.type = 'text/javascript';
    var useSSL = 'https:' == document.location.protocol;
    gads.src = (useSSL ? 'https:' : 'http:') +
      '//www.googletagmanager.com/gtag/js?id=' + config.adwordsTrackingId;
    var node = document.getElementsByTagName('script')[0];
    node && node.parentNode.insertBefore(gads, node);
  }
})();

function innerGTag() {
  dataLayer.push(arguments);
}

if (typeof document !== 'undefined') {
  innerGTag('js', new Date());

  let trackingOverride;

  let head = document.getElementsByTagName('head');
  if (head.length > 0) {
    trackingOverride = head[0].getAttribute('data-tracking');
  }

  if (trackingOverride) {
    let buildTrackingURL = function (trackingPathname) {
      if (typeof trackingPathname !== 'undefined' && trackingPathname !== '') {
        // If the tracking pathname is set, construct the tracking URL
        return window.location.protocol + '//' + window.location.host + trackingPathname + window.location.hash;
      } else {
        return window.location.href;
      }
    };

    innerGTag('config', 'AW-1032469392', {
      'page_path': trackingOverride,
      'page_location': buildTrackingURL(trackingOverride)
    });
  } else {
    innerGTag('config', 'AW-1032469392');
  }

  window.addEventListener('load', function () {
    let path = window.location.pathname;

    if (config.adwordsTrackingId && config.adwordsConversions && config.adwordsConversions[path]) {
      console.log('Track conversion');
      console.log(`${config.adwordsTrackingId}/${config.adwordsConversions[path]}`);
      console.log(innerGTag, dataLayer);
      innerGTag('event', 'conversion', {'send_to': `${config.adwordsTrackingId}/${config.adwordsConversions[path]}`});
    }
  });

  // Google tag configuration
  var gtagScript = document.createElement('script');
  gtagScript.async = true;
  gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-6EFN2GM1EK';
  var gtagConfig = document.createElement('script');
  gtagConfig.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'G-6EFN2GM1EK');
  `;

  document.head.appendChild(gtagScript);
  document.head.appendChild(gtagConfig);

  // Define a function to check if the gtag.js is loaded and firing
  function checkGtagFiring() {
    if (typeof gtag !== 'undefined') {
      // The gtag.js is loaded and available
      console.log('Google Analytics Global Site Tag is firing!');
      // You can also trigger a custom event here
      // For example: gtag('event', 'page_view', { 'send_to': 'your_tracking_id' });
    } else {
      // The gtag.js is not loaded yet, wait and check again
      setTimeout(checkGtagFiring, 100);
    }
  }
  // Call the function to check if the gtag.js is firing
  checkGtagFiring();
}

export default dataLayer;
